import { Switch } from '@mui/material';
import { InputHTMLAttributes } from 'react';
import { getDeviceInfo } from 'state/localStorageTyped';

type SwitchControlProps = {
  disabled: boolean;
  checked: boolean;
  onChange: () => void;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
};

export const SwitchControl = (props: SwitchControlProps): JSX.Element => {
  const { disabled, checked, onChange, inputProps } = props;
  const deviceInfo = getDeviceInfo();

  return (
    <Switch
      disabled={disabled}
      edge="end"
      checked={checked}
      inputProps={inputProps}
      onClick={onChange}
      sx={
        // Native app webview, and web browser on iOS
        deviceInfo?.operatingSystem === 'ios'
          ? {
              // @linear:ENG-2317 Fixes issue on iOS where switch backgrounds sometimes don't appear
              willChange: 'transform, opacity', // Forces GPU to render it properly
            }
          : undefined
      }
    />
  );
};
